import { ReportType } from '@layout';
import { DealerType } from '@types';

export interface Admin {
  id: number;
  username: string;
  name: string;
  email?: string;
  phone?: string;
  visitCredits?: number;
  visitComments?: number;
  isSuperadmin: boolean;
  permissionKeys: Record<string, boolean>;
  roles: AdminRole[];
  isEnabled: boolean;
  createdAt: string;
  reports: ReportType[] | null;
  reportRange: string | null;
  reportType: string | null;
  isSalesRisk: boolean;
  isRisk: boolean;
  isRemoved: boolean;
  area: AdminArea;
  areaId: number;
}

export interface AdminArea {
  id: number;
  name: string;
  position: number;
  isEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AdminRole {
  id: number;
  name: string;
  isEnabled: boolean;
  isFixed: boolean | null;
  areas: AdminArea[];
  areaIds: number[];
}

export interface AdminNotification {
  id: number;
  userCode: string | null;
  userId: number | null;
  userName: string | null;
  creditCode: string | null;
  creditId: number | null;
  riskId: number | null;
  financeCostId: number | null;
  financeCost?: {id: number, code: string};
  financeWithdrawalId: number | null;
  financeWithdrawal?: {id: number, code: string};
  financeDepositId: number | null;
  financeDeposit?: {id: number, code: string};
  ticketFrom: string | null;
  managerId: number | null;
  manager?: {id: number, name: string, dealer?: {id: number, name: string, type: DealerType}};
  isRead: boolean;
  entity: string;
  createdAt: string;
  enabledAt: string | null;
  comment?: string;
}

export interface AdminSettingsOption {
  id?: number;
  idx: string;
  isSelected?: boolean;
  name: string;
  category: AdminOptionCats;
  position: number;
  isEnabled: boolean;
  lockedAt?: string | null;
}

export enum AdminOptionCats {
  CX_FARMS_CYCLE = 'cx_farms_cycle',
  PARTNERS_STATUS = 'partners_status',
  PARTNERS_TYPE_BUYER = 'partners_type_buyer',
  PARTNERS_TYPE_RETAILER = 'partners_type_retailer',
  PARTNERS_TYPE_ASSOCIATE = 'partners_type_associate',
  SALES_LEADS_STAGE = 'sales_leads_stage',
  SALES_USERS_INACTIVITY_REASONS = 'sales_users_inactivity_reasons',
  SALES_CREDITS_REASON_FOR_REJECTION = 'sales_credits_reason_for_rejection',
  SALES_CREDITS_RISK_REJECTION_REASON = 'sales_credits_risk_rejection_reason',
  PRODUCT_PRESENTATION = 'product_presentation',
  PRODUCT_PACK_SIZE = 'product_pack_size',
}
